<i class="fa fa-download" aria-hidden="true"
   (click)="onSaveCapture()"
></i>
